import { styled } from '@mui/material';
import moment from 'moment';
import { PageContext } from 'pages/CourseSetup/PageProvider';
import { useContext } from 'react';
import { Box, Button, DatePicker, Form, Icon, IconButton, Stack, Text, TextInput } from 'shell/components';

const GeneralInformation = ({
    errors,
    form,
    handleChange,
    handlePrev,
    handleClose,
    submitData,
    PAGES,
    isLti = false,
}) => {
    const { loading } = useContext(PageContext);
    return (
        <GeneralInformationBox>
            <Stack spacing={1} sx={{ mt: 6 }}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                    <Text variant={'p1'} color={'primary'}>
                        STEP 2 of 2
                    </Text>
                    {!isLti && (
                        <IconButton
                            aria-label={'close'}
                            kind={'exit'}
                            size={'medium'}
                            variant={'square'}
                            onClick={handleClose}
                        />
                    )}
                </Stack>
                <Text variant={'h6'} weight={'medium'}>
                    Project Details
                </Text>
                <Text variant={'p1'}>Input the details for the first project in this class.</Text>
            </Stack>
            <Form onSubmit={() => submitData()}>
                <InputStack spacing={6}>
                    <TextInput
                        error={Boolean(errors.projectName)}
                        helperText={errors.projectName}
                        label={'Project Title'}
                        onChange={(e) => handleChange('projectName', e.target.value)}
                        placeholder={'Enter title'}
                        value={form.projectName}
                        required
                    />
                    <Stack direction={'row'} spacing={4}>
                        <DatePicker
                            disabledDate={(date) => date.isSameOrBefore(moment().subtract(1, 'day'))}
                            label={'Start Date'}
                            value={form.start_on}
                            onChange={(value) => handleChange('start_on', value)}
                        />

                        <DatePicker
                            disabledDate={(date) => date.isSameOrBefore(moment(form.start_on).subtract(1, 'day'))}
                            label={'End Date'}
                            value={form.end_on}
                            onChange={(value) => handleChange('end_on', value)}
                        />
                    </Stack>
                </InputStack>

                <Stack
                    justifyContent={'space-between'}
                    direction={'row'}
                    sx={{ margin: (theme) => theme.spacing(6, 0, 2, 0) }}
                >
                    <Button
                        color={'neutral'}
                        onClick={() => handlePrev(PAGES.GENERAL_INFORMATION)}
                        startIcon={<Icon kind={'arrowLeft'} />}
                        variant={'tertiary'}
                    >
                        Back
                    </Button>
                    <Button
                        data-cy={'project-details-complete-button'}
                        loading={loading}
                        sx={{ width: '95px' }}
                        type={'submit'}
                    >
                        Complete
                    </Button>
                </Stack>
            </Form>
        </GeneralInformationBox>
    );
};

const GeneralInformationBox = styled(Box)(({ theme }) => {
    return {
        width: '100%',
        height: '100%',
        background: theme.palette.ensightful.shades[0],
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

export default GeneralInformation;
